// Author: arshadthaheem.com

// ==== SHOW / HIDE COLLECTION ITEMS IN BRAND PAGE

document.addEventListener('DOMContentLoaded', function() {
    document.addEventListener('click', function(e) {
        // 1. Safely find the button even if clicking the inner text
        const toggleBtn = e.target.closest('#toggle-collections');
        
        if (toggleBtn) {
            e.preventDefault();
            const wrapper = toggleBtn.closest('[data-collection-toggle-container]');
            if (!wrapper) return;

            const shopifySection = wrapper.closest('.shopify-section');
            if (!shopifySection) return;

            const previousSection = shopifySection.previousElementSibling;
            if (!previousSection) return;

            const gridContainer = previousSection.querySelector('flickity-component');

            if (gridContainer) {
                if (!gridContainer.classList.contains('is-expanded')) {
                    // SHOW MORE
                    gridContainer.classList.add('is-expanded');
                    toggleBtn.textContent = 'SHOW LESS';
                    window.scrollBy({ top: 150, behavior: 'smooth' });
                } else {
                    // SHOW LESS (with delay)
                    gridContainer.classList.add('is-closing');
                    toggleBtn.textContent = 'SHOW MORE';

                    setTimeout(() => {
                        gridContainer.classList.remove('is-expanded');
                        gridContainer.classList.remove('is-closing');
                        gridContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }, 400);
                }
            }
        }
    });
});

